import styled from 'styled-components';
// @ts-ignore
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const SlideWrap = styled.div<{slideMargin: number, slideWidth: number}>`
    display: flex;
    flex-direction: column;
    margin-right: ${p=>`${p.slideMargin}px`};
    width: ${p=>`${p.slideWidth}px`};
    height: 324px;
    overflow: hidden;
`;

export const Image = styled.img`
    flex: 0 0 auto;
    width: 100%;
`;

export const SlideLink = styled.a`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    color: #cce4fb;

    &:hover {
        color: ${COLORS.lightRed};
    }
`;

export const SlideDesc = styled.div`
    flex: 1 0 auto;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 5px 10px;
    background-color: #333;
`;

export const SlideTitle = styled.div`
    width: 100%;
    font-size: 15px;
    overflow: hidden;
`;

export const SlideCost = styled.div`
    margin-top: 5px;
    width: 100%;
    font-size: 17px;
    overflow: hidden;
`;
